import React from "react";
import { Form, Input, Button, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
// import axios from "axios";
import api from "shared/api/client";

interface LoginProps {
  setAuth: (auth: boolean) => void;
}

const LoginComponent: React.FC<LoginProps> = ({ setAuth }) => {
  const [form] = Form.useForm();

  const handleLogin = async (values: {
    username: string;
    password: string;
  }) => {
    try {
      const res = await api.post("/auth/login", values);

      const accessToken = res.data.accessToken;
      const refreshToken = res.data.refreshToken;
      const user = res.data.user;

      if (!accessToken || !refreshToken) {
        message.error("Token ирсэнгүй. Backend login response шалга.");
        console.error("TOKEN MISSING:", res.data);
        return;
      }
      localStorage.setItem("userId", user.id);
      // localStorage.setItem("userrealname", user.userrealname || user.username);
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("userRole", user.role);
      localStorage.setItem("userrealname", user.userrealname || user.username);

      setAuth(true);

      message.success(
        `${user.userrealname || user.username} амжилттай нэвтэрлээ!`
      );

      form.resetFields();
    } catch (err: any) {
      message.error(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <Form form={form} onFinish={handleLogin} layout="vertical">
      <Form.Item
        label="Username"
        name="username"
        rules={[{ required: true, message: "Нэрээ оруул!" }]}
      >
        <Input prefix={<UserOutlined />} placeholder="Username" />
      </Form.Item>

      <Form.Item
        label="Password"
        name="password"
        rules={[{ required: true, message: "Нууц үг оруул!" }]}
      >
        <Input.Password
          autoComplete="off"
          prefix={<UserOutlined />}
          placeholder="Password"
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          Нэвтрэх
        </Button>
      </Form.Item>
    </Form>
  );
};

export default LoginComponent;
